import { render, staticRenderFns } from "./ScoreCards.vue?vue&type=template&id=d2cc7b5e&"
import script from "./ScoreCards.vue?vue&type=script&lang=js&"
export * from "./ScoreCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports